import type { SVGProps } from 'react';
const SvgCastForEducation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#cast_for_education_svg__a)">
      <path
        fill="currentColor"
        d="M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2ZM1 18v3h3c0-1.66-1.34-3-3-3Zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7Zm0-4v2a9 9 0 0 1 9 9h2c0-6.08-4.93-11-11-11Zm10 1.09v2L14.5 15l3.5-1.91v-2L14.5 13 11 11.09ZM14.5 6 9 9l5.5 3L20 9l-5.5-3Z"
      />
    </g>
    <defs>
      <clipPath id="cast_for_education_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCastForEducation;
